import { connect } from 'react-redux';

import { login, clearLoginError } from '../../../Redux/user-profile/actions';
import { isLogin, loginError, myProfile } from '../../../Redux/user-profile/selectors';
import LoadingLoginView from './LoginLoading';

export default connect(
  (state) => ({ isLogin: isLogin(state), loginError: loginError(state), user: myProfile(state) }),
  {
    login,
    clearLoginError,
  }
)(LoadingLoginView);
